module.exports = __webpack_public_path__ + "static/media/norwegian.fb5ed4df.svg";